'use client';

import { useCallback, useState } from 'react';
import { ClipCarousel, type IClipSwiperItem } from './clip-carousel';
import { ClipSlide } from './clip-slide';

interface IClipPhoneSwiperProps {
  clips: IClipSwiperItem[];
  language: string;
}

const VIEWPORT_CLASS = 'relative size-full overflow-hidden rounded-[inherit]';

export function ClipPhoneSwiper({
  clips,
  language,
}: IClipPhoneSwiperProps): React.JSX.Element | null {
  const [isMuted, setIsMuted] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  const handleTap = useCallback(() => {
    if (isMuted) {
      setIsMuted(false);
      setIsPaused(false);
      return;
    }
    setIsPaused((paused) => !paused);
  }, [isMuted]);

  const resetPlayback = useCallback(() => setIsPaused(false), []);

  const firstClip = clips[0];
  if (!firstClip) {
    return null;
  }

  if (clips.length === 1) {
    return (
      <div className={VIEWPORT_CLASS}>
        <ClipSlide
          src={firstClip.verticalUrl}
          transcript={firstClip.transcript}
          language={language}
          parentTitle={firstClip.parentTitle}
          collectionTitle={firstClip.collectionTitle}
          isActive
          isMuted={isMuted}
          isPaused={isPaused}
          loop
          onTap={handleTap}
        />
      </div>
    );
  }

  return (
    <ClipCarousel
      clips={clips}
      language={language}
      isMuted={isMuted}
      isPaused={isPaused}
      onTap={handleTap}
      onClipChange={resetPlayback}
    />
  );
}
